import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import ReactGA from 'react-ga4';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { displayConsoleMessages } from './consoleUtils';
import './index.css';

// TODO: Move this to env
const trackingId = 'G-DFXW4FR1BJ';
ReactGA.initialize(trackingId);

// Display console messages
displayConsoleMessages();

const root = document.getElementById('root');
const app = (
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Production pages are prerendered (scripts/prerender.js); dev serves an empty shell
if (root.hasChildNodes()) hydrateRoot(root, app);
else createRoot(root).render(app);
